const KEY = 'happytimes.traffic.v1';
const SOURCES = { whatsapp_stories:'whatsapp_stories', whatsapp_channel:'whatsapp_channel', wa:'whatsapp', whatsapp:'whatsapp', ig:'instagram', instagram:'instagram', fb:'facebook', facebook:'facebook', x:'x', twitter:'x', telegram:'telegram', google:'google', bing:'bing' };
let current, lastActivity = 0;
export function taggedShareUrl(url, source) {
  const link = new URL(url, window.location.origin);
  link.searchParams.set('utm_source', source);
  link.searchParams.set('utm_medium', 'social');
  return link.href;
}
export function captureTrafficSource() {
  if (current) {
    if (Date.now()-lastActivity >= 30*60*1000) current = {source:'direct'};
    lastActivity = Date.now();
    return current;
  }
  const params = new URLSearchParams(window.location.search);
  const tagged = params.get('utm_source')?.toLowerCase().trim();
  let source = tagged ? (SOURCES[tagged] || 'other') : null;
  if (!source) {
    try {
      const host = new URL(document.referrer).hostname.toLowerCase();
      if (host !== window.location.hostname) {
        source = ['whatsapp','instagram','facebook','telegram','google','bing'].find(name => host === `${name}.com` || host.endsWith(`.${name}.com`));
        if (host === 'wa.me' || host === 'web.whatsapp.com') source = 'whatsapp';
        if (host === 't.me' || host === 'telegram.me') source = 'telegram';
        if (host === 't.co' || host === 'x.com' || host.endsWith('.x.com') || host === 'twitter.com' || host.endsWith('.twitter.com')) source = 'x';
        source = source || 'other';
      }
    } catch {}
  }
  // Preserve the original source while a visitor browses or reloads within 30 minutes.
  if (!source) try {
    const previous = JSON.parse(sessionStorage.getItem(KEY));
    if (previous && Date.now()-previous.lastSeen < 30*60*1000) source = previous.source;
  } catch {}
  current = { source: source || 'direct' };
  lastActivity = Date.now();
  try { sessionStorage.setItem(KEY, JSON.stringify({...current,lastSeen:Date.now()})); } catch {}
  return current;
}
export function getTrafficSource() {
  const result = captureTrafficSource();
  try { sessionStorage.setItem(KEY, JSON.stringify({...result,lastSeen:Date.now()})); } catch {}
  return result;
}
